module.exports = __webpack_public_path__ + "img/ZNZBZZYJC_2.d796ce9e.jpg";